/*
const addLight = (color:string, amount:number)=>{
    const cc = parseInt(color,16) + amount;
    const c = (cc > 255) ? 255 : (cc);
    const c2 = (c.toString(16).length > 1 ) ? c.toString(16) : `0${c.toString(16)}`;
    return c2;
  }
  */
  /* Aclara un color hexadecimal de 6 caracteres #RRGGBB segun el porcentaje indicado 
  const lighten = (color:string, amount:number)=> {
    color = (color.indexOf("#")>=0) ? color.substring(1,color.length) : color;
    amount = (255* amount) / 100;
    return color = `#${addLight(color.substring(0,2), amount)}${addLight(color.substring(2,4), amount)}${addLight(color.substring(4,6), amount)}`;
  }
  *
  /* Resta el porcentaje indicado a un color (RR, GG o BB) hexadecimal para oscurecerlo */
  const subtractLight = (color:string, amount:number)=>{
    const cc = parseInt(color,16) - amount;
    const c = (cc < 0) ? 0 : (cc);
    const c2 = (c.toString(16).length > 1 ) ? c.toString(16) : `0${c.toString(16)}`;
    return c2;
  }
  
  /* Oscurece un color hexadecimal de 6 caracteres #RRGGBB segun el porcentaje indicado */
  const darken = (color:string, amount:number) =>{
    color = (color.indexOf("#")>=0) ? color.substring(1,color.length) : color;
    amount = (255*amount)/100;
    return color = `#${subtractLight(color.substring(0,2), amount)}${subtractLight(color.substring(2,4), amount)}${subtractLight(color.substring(4,6), amount)}`;
  }
export default class Marker{
 
    
    destacado(color = '#6f6e6e'):string {
     
        const svg = `<svg width="80" height="112" xmlns="http://www.w3.org/2000/svg" fill="none">

        <g>
         <title>Layer 1</title>
         <circle id="svg_1" fill-opacity="0.5" fill="#CCCADA" r="32" cy="80" cx="40"/>
         <circle id="svg_2" fill-opacity="0.6" fill="#B6B2CC" r="24" cy="80" cx="40"/>
         <circle id="svg_3" fill="${darken(color,20)}" r="16" cy="80" cx="40"/>
         <path id="svg_4" fill="${color}" d="m64.4001,27.734c0,-6.4713 -2.5707,-12.6775 -7.1466,-17.2534c-4.5759,-4.57591 -10.7821,-7.14662 -17.2534,-7.14662c-6.4713,0 -12.6775,2.57071 -17.2534,7.14662c-4.5759,4.5759 -7.1466,10.7821 -7.1466,17.2534l0,1.6667c0,12.2999 17.6,32.7666 23,46.2999c0.1089,0.283 0.3009,0.5264 0.5508,0.698c0.2499,0.1717 0.546,0.2635 0.8492,0.2635c0.3032,0 0.5993,-0.0918 0.8492,-0.2635c0.2499,-0.1716 0.442,-0.415 0.5508,-0.698c5.4,-13.5333 23,-34 23,-46.2999l0,-1.6667z"/>
        <path id="svg_7" fill="white" d="m48.8311,17.5997c0.2519,0 0.4981,-0.0753 0.707,-0.216c0.209,-0.1407 0.3713,-0.3405 0.4661,-0.5739c0.0948,-0.2334 0.1178,-0.4898 0.0662,-0.7364c-0.0516,-0.2465 -0.1756,-0.4721 -0.3561,-0.6479c-0.1805,-0.1757 -0.4093,-0.2936 -0.6572,-0.3387c-0.2478,-0.045 -0.5035,-0.0151 -0.7343,0.0859c-0.2308,0.101 -0.4262,0.2685 -0.5613,0.4811c-0.1351,0.2127 -0.2037,0.4608 -0.1971,0.7126c0.0087,0.3301 0.146,0.6438 0.3826,0.8742c0.2366,0.2304 0.5538,0.3593 0.8841,0.3591z"/>
         <text xml:space="preserve" text-anchor="start" font-family="Noto Sans JP" font-size="24" stroke-width="0" id="svg_8" y="21.16189" x="35.94596" fill="#000000"/>
        </g>
       </svg>`;
               return 'data:image/svg+xml;base64,'+btoa(svg);
    }
    getAnimado(color  = '#6f6e6e'): string
    {
        const svg = `<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g>
                <circle cx="13" cy="13" r="8" fill="${color}"  filter="url(#filter1_d)"/>
                <circle cx="13" cy="13" r="7" fill="none" stroke="${color}" stroke-width="2">    
                    <animate attributeName="r" from="7" to="13" dur="1.5s" begin="0s" repeatCount="indefinite"/>
                    <animate attributeName="opacity" from="1" to="0.5" dur="1.5s" begin="0s" repeatCount="indefinite"/>
                </circle>
                
            </g>
     <defs>
<filter id="filter1_d" x="0" y="0" width="24" height="24" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
<feOffset dy="0"/>
<feGaussianBlur stdDeviation="2"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
</filter>
</defs>
            </svg>`;
        return 'data:image/svg+xml;base64,'+btoa(svg);
    }
    generarIc(color = '#6f6e6e'):string
    {       
        const svg = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
            '<g filter="url(#filter0_d)">\n' +
            '<circle cx="12" cy="14" r="8" fill="'+color+'"/>\n' +
            '<circle cx="12" cy="14" r="7" stroke="white" stroke-width="2"/>\n' +
            '</g>\n' +
            '<defs>\n' +
            '<filter id="filter0_d" x="0" y="0" width="24" height="24" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">\n' +
            '<feFlood flood-opacity="0" result="BackgroundImageFix"/>\n' +
            '<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>\n' +
            '<feOffset dy="-4"/>\n' +
            '<feGaussianBlur stdDeviation="2"/>\n' +
            '<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>\n' +
            '<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>\n' +
            '<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>\n' +
            '</filter>\n' +
            '</defs>\n' +
            '</svg>\n';

        return 'data:image/svg+xml;base64,'+btoa(svg);
    }
    
}